export const formProdutoBlankCompleto = {
  // ===== Identificação
  des_produto: '',
  des_reduzida: '',
  des_referencia: '',
  des_unidade_compra_fornecedor: { label: 'UN - Unidade', value: 'UN' },
  qtd_embalagem_compra_fornecedor: 1,

  // ===== Relacionamentos
  cod_departamento: { value: undefined, label: '' },
  cod_tipo_item: { value: undefined, label: '' },
  cod_id_ctb: { value: undefined, label: '' },
  cod_tara: { value: undefined, label: 'Selecione a Tara' },
  cod_vasilhame: {
    value: undefined,
    label: 'Código ou Descrição do Vasilhame',
  },
  cod_receita: { value: undefined, label: 'Selecione a Receita' },
  cod_info_nutricional: { value: undefined, label: 'Selecione a Inf. Nutr.' },

  // ===== Fiscal
  cod_ncm: { value: undefined, label: '' },
  cod_sped: '',
  des_sped: '',
  cod_tab_sped: { value: undefined, label: '' },
  des_tab_sped: { value: undefined, label: '' },

  // ===== Tributação
  cod_trib_entrada: { value: undefined, label: undefined },
  cod_tributacao: { value: undefined, label: undefined },
  tipo_nao_pis_cofins: { value: undefined, label: undefined },

  // ===== IPI
  ipi_tipo: { value: -1, label: 'Nenhum' },
  ipi_val: '',

  // ===== PIS/COFINS
  entrada_pis_cofins: { value: null, label: '= Saída' },

  // ===== ICMS
  per_veda_cred_lim: '',

  // ===== Unidades
  des_unidade_compra: { label: 'UN - Unidade', value: 'UN' },
  qtd_embalagem_compra: 1,
  des_unidade_venda: { label: 'UN - Unidade', value: 'UN' },
  qtd_embalagem_venda: 1,

  // ===== Pesos
  val_peso: '1,000',
  val_peso_emb: '1,000',
  val_peso_bruto: '1,000',
  qtd_divisor_preco: '1,000',
  des_unidade_medida_preco: { label: 'UN - Unidade', value: 'UN' },

  // ===== Associação
  tipo_associado: 0,
  associados_pai: [],
  associados_filho: [],

  // ===== Grade
  tipo_variacao: { value: 0, label: 'Não possui' },

  // ===== Fornecedores
  fornecedores: [],
  cod_similar: { value: undefined, label: 'Nenhum Similar Selecionado' },
  cod_marca: { value: undefined, label: 'Nenhuma Marca Selecionada' },

  // ===== Rastreamento
  num_lote_rast: '',
  qtd_lote_rast: 0,
  cod_agreg_rast: 0,

  // ===== IBS / CBS
  cod_ibs_cbs: null,
  per_aliq_cbs: '',
  per_red_cbs: '',
  val_red_social: 0,

  // ===== Estoque
  qtd_est_minimo: null,

  // ===== Outros
  tecla_balanca: '',
  qtd_etiqueta: 1,
  tipo_movimentacao: { label: 'Direta', value: 0 },
  tipo_multiplicacao: { label: 'Sim', value: 1 },
  per_perda: '',
  qtd_dias_validade: 0,

  // ===== Arrays
  embalagens: [],

  // ===== ANP
  cod_anp: '',
  per_glp: '',
  per_gnn: '',
  per_gni: '',
  val_partida: '',
  des_unidade_tributavel: '',

  // ===== GTIN
  Gtins: {
    gtins: [],
    isInvalid: false,
    isRequired: false,
  },
};
